import { object, func } from 'prop-types';

import styles from '../../../MarketIndex/MarketDetail/index.module.scss';
import { renderPrice, renderArea } from '../../../../utils/helpers/formater';

const DetailInfo = ({
  translateDetailInfo,
  houseDetail,
  translateListing,
  currentHouse,
}) => (
  <>
    <div className="col-lg-3">
      <div className="d-flex align-items-center g-pb-10 g-pt-10 g-color-gray-dark-v3">
        <p className="font-weight-bold g-font-size-16 m-0 mr-2">Objekt:</p>
        <p style={{ marginBottom: '0' }}>
          {translateDetailInfo(
            houseDetail?.objectClass?.toUpperCase(),
            translateListing.object_class,
          )}
        </p>
      </div>
      <div className="g-color-gray-dark-v3 d-flex align-items-center g-pb-10 g-pt-10 g-brd-bottom g-brd-black-bottom">
        <p className={`m-0 ${styles.detailHouse}`}>
          {`${houseDetail?.zipCode ? houseDetail.zipCode : ''}, 
        ${currentHouse?.fullTitle ? currentHouse.fullTitle : ''}`}
        </p>
      </div>
      <div className="g-color-gray-dark-v3 d-flex align-items-center g-pb-10 g-pt-10 g-brd-bottom g-brd-black-bottom">
        {' '}
        <p className={`m-0 ${styles.house}`}>
          {`${
            houseDetail?.numberOfRooms ? houseDetail.numberOfRooms : ''
          } Zimmer`}
        </p>
      </div>
      <div className="d-flex align-items-center g-pb-10 g-pt-10 g-brd-bottom g-brd-black-bottom">
        <p className={`m-0 ${styles.house}`}>
          {renderArea(houseDetail?.livingSpace ? houseDetail.livingSpace : '')}{' '}
        </p>
      </div>
      <div className="d-flex align-items-center g-pb-10 g-pt-10 g-brd-bottom g-brd-black-bottom">
        <p className="g-color-gray-dark-v3 m-0 font-weight-bold g-font-size-24">
          {renderPrice(houseDetail)}
        </p>
      </div>
    </div>
    <div className="col-lg-3">
      <div className="d-flex g-pb-10 g-pt-10">
        <p className="g-color-gray-dark-v3 m-0 font-weight-bold g-font-size-16 ">
          Objekt Eigenschaften
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex justify-content-between align-items-center g-pb-10 g-pt-10
             g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.detailHouse}`}>Kategorie:</p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail?.objectCategory?.toUpperCase() || '-',
            translateListing?.object_category,
          )}
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex justify-content-between align-items-center g-pb-10 g-pt-10
               g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Baujahr:</p>
        <p className="m-0">{houseDetail?.yearOfConstruction || '-'}</p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex justify-content-between align-items-center g-pb-10 g-pt-10
            g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Ausstattung:</p>
        <p className="m-0">{houseDetail?.quality || '-'}</p>
      </div>
      <div
        className="d-flex justify-content-between align-items-center g-pb-10 g-pt-10 g-brd-bottom
            g-color-gray-dark-v3 g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Zustand:</p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail.condition?.toUpperCase() || '-',
            translateListing.condition,
          )}
        </p>
      </div>
    </div>
    <div className="col-lg-3">
      <div className="g-color-gray-dark-v3 d-flex g-pb-10 g-pt-10">
        <p className="m-0 font-weight-bold g-font-size-16 g-color-white">
          Objekt Eigenschaften
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex align-items-center justify-content-between g-pb-10 g-pt-10
            g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.detailHouse}`}>Balkon/Terrasse:</p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail.terrace?.toUpperCase() || '-',
            translateListing.terrace,
          )}
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex align-items-center justify-content-between g-pb-10 g-pt-10
            g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Keller:</p>
        <p className="m-0">{houseDetail?.cellar || '-'}</p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex align-items-center justify-content-between g-pb-10 g-pt-10
             g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Aufzug:</p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail.elevator?.toUpperCase() || '-',
            translateListing.auto_lift,
          )}
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex align-items-center justify-content-between g-pb-10 g-pt-10
             g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Parkplatz:</p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail.parking?.toUpperCase() || '-',
            translateListing.parking_type,
          )}
        </p>
      </div>
    </div>
    <div className="col-lg-3">
      <div className="g-color-gray-dark-v3 d-flex g-pb-10 g-pt-10">
        <p className="font-weight-bold g-font-size-16 m-0">
          Energetische Angaben
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex justify-content-between g-pb-10 g-pt-10 g-brd-bottom
            align-items-center g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.detailHouse}`}>Energieträger: </p>
        <p className="m-0">
          {translateDetailInfo(
            houseDetail.energySources?.toUpperCase() || '-',
            translateListing.energy_source,
          )}
        </p>
      </div>
      <div
        className="g-color-gray-dark-v3 d-flex justify-content-between align-items-center g-pb-10 g-pt-10
            g-brd-bottom g-brd-black-bottom"
      >
        <p className={`m-0 ${styles.house}`}>Endbedarf:</p>
        <p className="m-0">{houseDetail.energyConsumption}</p>
      </div>
    </div>
  </>
);

DetailInfo.propTypes = {
  houseDetail: object.isRequired,
  translateListing: object,
  translateDetailInfo: func.isRequired,
  currentHouse: object.isRequired,
};

DetailInfo.defaultProps = {
  translateListing: {},
};

export default DetailInfo;
